// Module
var code = "<h2 id=\"pagecenterx\">PageCenterX</h2> <p>View and print disbursement, asset management, LaRS, and other reports.</p> ";
// Exports
export default code;